var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNativeLaboratoireLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "939px",
    height: "281px",
    viewBox: "0 0 939 281",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "native_laboratoire_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "native_laboratoire_logo",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#222221",
    points: "0.06 279.3 0.06 246.53 4.85 246.53 4.85 274.53 24.79 274.53 24.79 279.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.64,279.3 L67.94,268.63 L53.23,268.63 L48.35,279.3 L43.17,279.3 L58.06,246.58 L63.33,246.58 L78,279.3 L72.64,279.3 Z M60.64,252.38 L55.42,263.8 L65.79,263.8 L60.64,252.38 Z",
    id: "Shape",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.45,276.71 C126.77,279.21 124.45,279.3 121.02,279.3 L102.22,279.3 L102.22,246.53 L121,246.53 C126.53,246.53 130.66,249.74 130.66,255.53 C130.741119,258.024005 129.653855,260.413026 127.72,261.99 C130.39,264.1 132.24,266.87 132.24,270.38 C132.264912,272.793316 131.248132,275.100205 129.45,276.71 L129.45,276.71 Z M121,251.28 L107,251.28 L107,260.06 L121,260.06 C123.89,260.06 125.87,258.57 125.87,255.54 C125.87,252.51 123.91,251.28 121,251.28 Z M121,264.94 L107,264.94 L107,274.47 L121.5,274.47 C123.26,274.47 124.84,274.34 126.15,273.02 C127.026061,272.1451 127.518839,270.958117 127.52,269.72 C127.52,265.9 124.22,264.94 121,264.94 Z",
    id: "Shape",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.09,280.09 C169.396021,280.13889 164.880754,278.292358 161.566139,274.968332 C158.251524,271.644305 156.417802,267.123821 156.48,262.43 C156.48,252.81 164.74,245.57 174.14,245.57 C178.797058,245.511066 183.283133,247.322677 186.593307,250.599016 C189.903482,253.875356 191.761086,258.342583 191.750049,263 C191.750049,272.62 183.58,280.09 174.09,280.09 Z M174.09,250.4 C166.8,250.4 161.18,255.62 161.18,263 C161.18,270.08 167.28,275.26 174.18,275.26 C177.5488,275.30536 180.796518,274.004996 183.203114,271.647207 C185.60971,269.289419 186.976335,266.069022 187,262.7 C187,255.49 181.08,250.4 174.09,250.4 L174.09,250.4 Z",
    id: "Shape",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.4,265.55 L248.21,279.3 L242.81,279.3 L236.22,265.73 L224,265.73 L224,279.3 L219.21,279.3 L219.21,246.53 L238.62,246.53 C244.62,246.53 248.94,249.96 248.94,256.2 C249,261.16 246.14,264.41 241.4,265.55 Z M238.63,251.28 L224,251.28 L224,260.94 L238.62,260.94 C241.87,260.94 244.2,259.4 244.2,255.94 C244.2,252.48 241.75,251.28 238.63,251.28 Z",
    id: "Shape",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.69,279.3 L294,268.63 L279.28,268.63 L274.4,279.3 L269.22,279.3 L284.11,246.58 L289.38,246.58 L304.05,279.3 L298.69,279.3 Z M286.69,252.38 L281.5,263.8 L291.87,263.8 L286.69,252.38 Z",
    id: "Shape",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#222221",
    points: "340.7 251.32 340.7 279.32 336 279.32 336 251.32 324.36 251.32 324.36 246.53 352.25 246.53 352.25 251.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.64,280.09 C388.940849,280.147034 384.417776,278.304099 381.096613,274.97917 C377.77545,271.654241 375.937641,267.129084 376,262.43 C376,252.81 384.26,245.57 393.66,245.57 C398.322221,245.502955 402.816073,247.310977 406.132786,250.588205 C409.449498,253.865432 411.311207,258.33731 411.30005,263 C411.30005,272.62 403.13,280.09 393.64,280.09 Z M393.64,250.4 C386.35,250.4 380.73,255.62 380.73,263 C380.73,270.08 386.83,275.26 393.73,275.26 C397.105676,275.316129 400.363728,274.020539 402.779028,271.661584 C405.194327,269.302629 406.566447,266.076061 406.59,262.7 C406.55,255.49 400.63,250.4 393.64,250.4 L393.64,250.4 Z",
    id: "Shape",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#222221",
    points: "438.59 279.3 438.59 246.53 443.29 246.53 443.29 279.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.69,265.55 L501.5,279.3 L496.1,279.3 L489.51,265.73 L477.3,265.73 L477.3,279.3 L472.51,279.3 L472.51,246.53 L491.93,246.53 C497.93,246.53 502.25,249.96 502.25,256.2 C502.25,261.16 499.44,264.41 494.69,265.55 Z M491.93,251.28 L477.3,251.28 L477.3,260.94 L491.93,260.94 C495.18,260.94 497.5,259.4 497.5,255.94 C497.5,252.48 495,251.28 491.93,251.28 Z",
    id: "Shape",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#222221",
    points: "528.4 279.3 528.4 246.53 555.4 246.53 555.4 251.36 533.19 251.36 533.19 259.93 544.34 259.93 544.34 264.67 533.19 264.67 533.19 274.51 556.19 274.51 556.19 279.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.71,265.38 L682.48,265.38 L682.48,279.3 L677.7,279.3 L677.7,246.53 L696.7,246.53 C702.5,246.53 706.28,250 706.28,255.89 C706.28,261.78 702.47,265.38 696.71,265.38 Z M696.71,251.32 L682.48,251.32 L682.48,260.54 L696.71,260.54 C699.79,260.54 701.55,259.05 701.55,255.89 C701.55,252.73 699.88,251.32 696.71,251.32 Z",
    id: "Shape",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.94,279.3 L759.24,268.63 L744.52,268.63 L739.65,279.3 L734.47,279.3 L749.35,246.58 L754.62,246.58 L769.29,279.3 L763.94,279.3 Z M751.94,252.38 L746.76,263.8 L757.12,263.8 L751.94,252.38 Z",
    id: "Shape",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.47,265.55 L830.28,279.3 L824.88,279.3 L818.29,265.73 L806.08,265.73 L806.08,279.3 L801.29,279.3 L801.29,246.53 L820.7,246.53 C826.7,246.53 831.02,249.96 831.02,256.2 C831,261.16 828.21,264.41 823.47,265.55 Z M820.7,251.28 L806.08,251.28 L806.08,260.94 L820.7,260.94 C823.95,260.94 826.28,259.4 826.28,255.94 C826.28,252.48 823.82,251.28 820.7,251.28 Z",
    id: "Shape",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#222221",
    points: "864.69 279.3 864.69 246.53 869.39 246.53 869.39 279.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.42,280.05 C911.74,280.05 906.74,278.11 902.04,273.33 L905.38,270.12 C909.59,274.03 913.38,275.22 919.08,275.22 C922.73,275.22 929.23,274.07 929.23,269.33 C929.219854,267.781768 928.38006,266.357934 927.03,265.6 C925.32,264.5 923.69,264.41 918.86,264.32 L913.94,264.23 C908.85,264.15 904.19,261.47 904.19,255.84 C904.19,251.06 908.19,247.84 912.36,246.49 C914.19807,245.932289 916.109196,245.65253 918.03,245.66 C922.935267,245.619995 927.717574,247.194186 931.64,250.14 L929,254 C925.45,251.8 922.94,250.57 918.68,250.57 C915.47,250.57 909.06,251.57 909.06,255.84 C909.06,259.05 912.06,259.62 914.6,259.62 L919.47,259.62 C923.12,259.62 926.1,259.62 929.35,261.62 C932.250518,263.311047 934.015839,266.432836 933.97,269.79 C933.93,277.68 924.83,280.05 918.42,280.05 Z",
    id: "Path",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#222221",
    cx: 615.5,
    cy: 268.11,
    r: 4.49
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#415642",
    points: "14.98 198.41 0 198.41 0 4.45 18.65 4.45 146.91 147.81 146.91 4.45 161.89 4.45 161.89 202.91 153.75 202.91 14.97 44.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#86A390",
    points: "780.61 4.49 691.37 202.91 682.82 202.91 588.26 4.49 621.37 4.49 695.71 158.55 764.13 4.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#86A390",
    points: "938.26 16.99 938.26 4.45 836.24 4.45 803.58 4.45 803.58 16.99 803.58 86.08 803.58 98.72 803.58 185.59 803.58 198.41 836.24 198.41 938.26 198.41 938.26 185.59 836.24 185.59 836.24 98.72 904.68 98.72 904.68 86.08 836.24 86.08 836.24 16.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#86A390",
    points: "556.99 26.31 524.36 65.08 524.36 198.41 556.99 198.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.73,198.41 L371.83,198.41 L281.1,0 L272.56,0 L179.49,198.41 L196,198.41 L226.47,133.41 L309,133.41 L338.73,198.41 Z M232.26,121 L268.26,44.32 L303.31,121 L232.26,121 Z",
    id: "Shape",
    fill: "#415642"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#415642",
    points: "516.65 4.45 343.41 4.45 343.41 16.99 413.71 16.99 413.71 196.22 446.35 157.81 446.35 16.99 516.65 16.99"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNativeLaboratoireLogo);
export default __webpack_public_path__ + "static/media/native_laboratoire_logo.649a262c00288fbc9009adfa7d8d327c.svg";
export { ForwardRef as ReactComponent };